import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { PasswordControlComponent } from './password-control/password-control.component';
import { PasswordFormControlComponent } from './password-form-control.component';



@NgModule({
  declarations: [
    PasswordFormControlComponent,
    PasswordControlComponent
  ],
  exports: [
    PasswordFormControlComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormControlsUtilsModule
  ]
})
export class PasswordFormControlModule { }
